// extracted by mini-css-extract-plugin
export default {"page":"FastTrack_page__zRBSe","button":"FastTrack_button__w0E6x"};